import { render, staticRenderFns } from "./inventoryByBatchReport.vue?vue&type=template&id=24ee058b&"
import script from "./inventoryByBatchReport.vue?vue&type=script&lang=js&"
export * from "./inventoryByBatchReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports